var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.956 15.2467C27.7639 14.4803 30.4006 12.8219 30.4006 10.8996V6.89961C30.4006 4.09961 25.3846 2.09961 19.2006 2.09961C13.0166 2.09961 8.00059 4.09961 8.00059 6.89961V10.8996C8.00059 11.0441 8.01548 11.187 8.04463 11.3282C4.2375 12.0599 1.60059 13.6695 1.60059 15.6996V19.6996C1.60059 21.0075 2.82109 22.1932 4.80059 23.0589V26.8996C4.80059 29.5506 9.815 31.6996 16.0006 31.6996C22.1862 31.6996 27.2006 29.5506 27.2006 26.8996V22.8996C27.2006 21.5184 25.9799 20.3318 24.0006 19.4839V15.6996C24.0006 15.5462 23.9855 15.3951 23.956 15.2467Z",
    fill: "#F5DADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 23.0633V26.9009C4.7998 29.5519 9.81422 31.7009 15.9998 31.7009C22.1854 31.7009 27.1998 29.5519 27.1998 26.9009V22.9009C27.1998 21.5946 25.9792 20.409 23.9998 19.543",
    stroke: "#2D2926",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 19.541C25.9792 20.4068 27.1997 21.5925 27.1997 22.9003C27.1997 25.5513 22.1853 27.7003 15.9997 27.7003C9.94219 27.7003 5.00783 25.6393 4.80615 23.0643",
    stroke: "#2D2926",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05776 11.3516C4.2433 12.1176 1.6001 13.7784 1.6001 15.7007V19.7007C1.6001 22.3516 6.61451 24.5007 12.8001 24.5007C18.9857 24.5007 24.0001 22.3516 24.0001 19.7007V15.7007C24.0001 15.5466 23.9831 15.3942 23.9499 15.2437",
    stroke: "#2D2926",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08171 11.3457C4.25385 12.1088 1.6001 13.7717 1.6001 15.7002C1.6001 18.3512 6.61451 20.5002 12.8001 20.5002C18.9857 20.5002 24.0001 18.3512 24.0001 15.7002C24.0001 15.5443 23.9828 15.3901 23.9488 15.238",
    stroke: "#2D2926",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 15.6996C25.3856 15.6996 30.4 13.5506 30.4 10.8996V6.89961C30.4 4.25161 25.384 2.09961 19.2 2.09961C13.016 2.09961 8 4.25161 8 6.89961V10.8996C8 13.5506 13.0144 15.6996 19.2 15.6996Z",
    stroke: "#2D2926",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2,
    cy: 6.89961,
    rx: 11.2,
    ry: 4.8,
    stroke: "#2D2926",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5059 7.15981C16.4497 7.12614 16.3918 7.09622 16.3356 7.06068C16.1892 6.97703 16.0799 6.84091 16.0299 6.67982C15.9799 6.51873 15.9929 6.34467 16.0663 6.19279C16.1211 6.06396 16.197 5.94513 16.2908 5.84115C16.9793 5.08345 17.9229 4.60601 18.9412 4.50004C19.126 4.49906 19.3103 4.51787 19.4911 4.55615C19.3228 5.11728 19.0197 5.45583 18.4418 5.51382C18.2825 5.5321 18.1286 5.58306 17.9899 5.66352C17.8512 5.74398 17.7306 5.85221 17.6356 5.98143C17.8114 6.16848 17.9199 6.19466 18.135 6.05064C18.38 5.88604 18.6195 5.71209 18.8608 5.54C19.0152 5.42986 19.1959 5.36236 19.3847 5.3443C19.5735 5.32624 19.7638 5.35826 19.9363 5.43713C20.2187 5.54562 20.2561 5.81122 20.0204 5.99826C19.8521 6.14229 19.6688 6.26387 19.4967 6.39293C19.4967 6.41537 19.4967 6.42473 19.4967 6.42847C19.8895 6.85306 19.8932 6.8568 20.3908 6.56875C20.7517 6.38587 21.0922 6.16517 21.4064 5.91035C21.5579 5.77194 21.8198 5.74014 22.0386 5.69151C22.2245 5.66363 22.4119 5.64739 22.5998 5.64288C22.886 5.61669 23.0188 5.79252 22.8897 6.05438C22.7067 6.48805 22.3806 6.84587 21.9657 7.06816C21.7599 7.16916 21.5523 7.25521 21.3503 7.37491C20.8903 7.62015 20.5134 7.99641 20.2673 8.45603C20.1862 8.58394 20.0601 8.67673 19.9138 8.71602C19.5761 8.79543 19.2346 8.85786 18.8907 8.90307C18.6812 8.93674 18.569 8.82451 18.5839 8.60754C18.5989 8.39057 18.6232 8.13619 18.6438 7.90051C18.6421 7.81451 18.6165 7.73068 18.5699 7.65839C18.5233 7.58609 18.4575 7.52818 18.3799 7.49112C18.3023 7.45405 18.2159 7.4393 18.1303 7.44851C18.0448 7.45772 17.9636 7.49052 17.8956 7.54325C17.782 7.64954 17.6511 7.73558 17.5084 7.79763C17.4011 7.84809 17.2828 7.8706 17.1645 7.86307C17.0462 7.85554 16.9317 7.81822 16.8316 7.75458C16.7316 7.69094 16.6493 7.60304 16.5923 7.49906C16.5354 7.39507 16.5056 7.27837 16.5059 7.15981Z",
    fill: "#2D2926",
    stroke: "#2D2926",
    strokeWidth: 0.0787557,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBack);
export default __webpack_public_path__ + "static/media/money-back.fcda9b1ec250d2e6fd19e1062069c1bd.svg";
export { ForwardRef as ReactComponent };